import {Injectable} from "@angular/core";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../redux-store";

@Injectable()
export class DepotActions {
  static SELECT_DEPOT = 'SELECT_DEPOT';

  constructor(private ngRedux: NgRedux<IAppState>) {
  }

  selectDepot(id) {
    this.ngRedux.dispatch({
      type: DepotActions.SELECT_DEPOT,
      payload: id,
    });
  };

}



// WEBPACK FOOTER //
// ./src/app/shared/actions/depot.actions.ts